// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mention-typeahead-menu--fGlKJ{position:absolute;top:100%;left:0;z-index:1070;max-height:200px;overflow-y:auto;border:1px solid #f0f0f4;border-radius:10px;background-color:#fff;box-shadow:0 2px 4px rgba(40,28,90,.05),0 8px 24px rgba(40,28,90,.1);list-style:none}.mention-typeahead-menu--above--dUC_K{top:auto;bottom:calc(100% + 28px)}.mention-typeahead-menu--fGlKJ:empty{border:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mention-typeahead-menu": "mention-typeahead-menu--fGlKJ",
	"mention-typeahead-menu--above": "mention-typeahead-menu--above--dUC_K"
};
export default ___CSS_LOADER_EXPORT___;
